import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {hideModal} from '../actions/Modal';
import * as companyActions from '../actions/Company';
import CompanyComponent from '../components/Company/Company';

class PurchaseAddress extends React.Component {

    onSearchInputKeyPressed = (e) => {
        if(e.key == 'Enter'){
            this.props.searchCompaniesByText(this.props.company.textForSearching);
        }
    }

    onSearchInputTextChanged = (e) => this.props.updateTextForSearching(e.target.value);

    onSearchButtonClicked = () => this.props.searchCompaniesByText(this.props.company.textForSearching);

    onTablePageChange = (page) => this.props.changeTablePage(page);

    onSelectedTableRowChange = (row) => this.props.changeSelectedRow(row);

    onSaveButtonClick = () => this.props.onConfirmDialogClick(this.props.company.selectedRow);

    onDismissButtonClick = () => this.props.dismissChanges();

    render() {
        return(
            <CompanyComponent
                onSearchInputKeyPressed={this.onSearchInputKeyPressed}
                onSearchInputTextChanged={this.onSearchInputTextChanged}
                onSearchButtonClicked={this.onSearchButtonClicked}
                company={this.props.company}
                onTablePageChange={this.onTablePageChange}
                onSelectedTableRowChange={this.onSelectedTableRowChange}
                onSaveButtonClick={this.onSaveButtonClick}
                onDismissButtonClick={this.onDismissButtonClick}/>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        searchCompaniesByText: (text) => dispatch(companyActions.searchCompaniesByText(text)),
        updateTextForSearching: (text) => dispatch(companyActions.changeTextForSearching(text)),
        changeTablePage: (page) => dispatch(companyActions.changeTablePage(page)),
        changeSelectedRow: (selectedRow) => dispatch(companyActions.changeSelectedRow(selectedRow)),
        onConfirmDialogClick: (selectedRow) => dispatch(companyActions.ConfirmPurchaseAddressModal(selectedRow)),
        dismissChanges: () => dispatch(hideModal())
    };
};

const mapStateToProps = (state) => {
    return {
        company: state.company
    };
};

PurchaseAddress.propTypes = {
    searchCompaniesByTax: PropTypes.func,
    searchCompaniesByText:PropTypes.func,
    company: PropTypes.shape({
        textForSearching: PropTypes.string,
        selectedRow: PropTypes.object
    }),
    updateTextForSearching: PropTypes.func,
    changeTablePage: PropTypes.func,
    changeSelectedRow: PropTypes.func,
    onConfirmDialogClick: PropTypes.func,
    dismissChanges: PropTypes.func
};

export default connect(mapStateToProps,mapDispatchToProps)(PurchaseAddress);


// WEBPACK FOOTER //
// ./src/containers/PurchaseAddress.js